import Quill from "quill";

export type ImageClickHandler = (dataUrl: string) => void;
type ImagePopupOptions = {
	image?: ImageClickHandler;
};

export class OnClickModule {
	imageClickHandler?: ImageClickHandler;

	constructor(
		private _quill: Quill,
		options: ImagePopupOptions = {},
	) {
		this.imageClickHandler = options.image;
		this._quill.root.addEventListener("click", this._handleImageClick);
	}

	private _handleImageClick = (evt: MouseEvent) => {
		const target = evt.target as HTMLElement;
		if (target?.tagName?.toUpperCase() === "IMG") {
			evt.stopPropagation();

			const image = target as HTMLImageElement;
			this.imageClickHandler?.(image.src);
		}
	};
}
